module.exports = require("@angular/flex-layout/core");